import React, { useState } from "react";
import MenuSIdeBar from "./MenuSIdeBar/MenuSIdeBar";

const Menu = ({ isHome }) => {
  const [sideMenu, setSideMenu] = useState(false);

  return (
    <div className="absolute top-3 z-50 right-3 bg-transparent">
      <div className="flex justify-end">
        <a
          className="mr-3 hover:text-blue-800 transition-all font-medium"
          href="https://drive.google.com/u/0/uc?id=1DFFnNuf8RbaJ0XK03H1QxVjaMRFf5qV-&export=download"
          download
        >
          Download Resume
        </a>
        <svg
          onClick={() => (sideMenu ? setSideMenu(false) : setSideMenu(true))}
          xmlns="http://www.w3.org/2000/svg"
          className="h-7 w-7 cursor-pointer"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M4 6h16M4 12h16m-7 6h7"
          />
        </svg>
      </div>
      <div
        className={`h-screen transform ${
          sideMenu
            ? "w-3/4 md:w-1/2 translate-x-0 "
            : " opacity-100 w-0 translate-x-24"
        } transition-all bg-gray-300 z-40 fixed top-0 right-0 text-black p-3`}
      >
        <MenuSIdeBar setSideMenu={setSideMenu} isHome={isHome} />
      </div>
    </div>
  );
};

export default Menu;
